// extracted by mini-css-extract-plugin
export default {"csToken":"CSTokenPage_csToken__kdTOH"};